module.exports = __webpack_public_path__ + "files/73f7301a9cd7a086295401eefe0c998f.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-600italic.ttf
 ** module id = 957
 ** module chunks = 0
 **/